/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DarDto } from '../models/DarDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RemoteParticipantDarControllerService {

    /**
     * Lists all configured dars of a participant
     * @param name
     * @returns DarDto OK
     * @throws ApiError
     */
    public static listRemoteParticipantDars(
        name: string,
    ): CancelablePromise<Array<DarDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/remote-participants/{name}/dars',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Upload dar file to a participant
     * @param name
     * @param darName
     * @returns any OK
     * @throws ApiError
     */
    public static uploadRemoteParticipantDar(
        name: string,
        darName: Array<string>,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/remote-participants/{name}/dars',
            path: {
                'name': name,
            },
            query: {
                'darName': darName,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * Remove a dar from a participant
     * @param name
     * @param darHash
     * @returns any OK
     * @throws ApiError
     */
    public static removeRemoteParticipantDar(
        name: string,
        darHash: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/remote-participants/{name}/dars',
            path: {
                'name': name,
            },
            query: {
                'darHash': darHash,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
